// extracted by mini-css-extract-plugin
export default {"citation":"CitationMetadata_citation__r1DqA"};